import { Injectable } from '@angular/core';

export const loggingDbVersion = 3;
export const loggingDbStorageName = 'nimbus-logger';
export const avatarStorageName = 'nimbus-avatar';
export const loggingDbName = 'nimbus';

export const nimbusDbMigration: Record<number, (db: IDBDatabase) => void> = {
  3: (db) => {
    const storages = [loggingDbStorageName, avatarStorageName];

    storages.forEach((storage) => {
      if (!db.objectStoreNames.contains(storage)) {
        db.createObjectStore(storage);
      }
    });
  },
};

// noinspection JSUnusedGlobalSymbols
export enum LogLevel {
  Trace = 'Trace',
  Debug = 'Debug',
  Info = 'Info',
  Warn = 'Warn',
  Error = 'Error',
  Fatal = 'Fatal',
}

@Injectable()
export abstract class IClientSideLogger {
  public abstract writeMessage(logLevel: LogLevel, logName: string, message: string): void;
  public abstract proxyMessage(logName: string, message: string): void;
}
